
    import {Component, Vue} from 'vue-property-decorator';
    import {IPage} from "@/js/page";
    import {manufactoryApi, userApi} from "@/api/organization";
    import AddManufactory from "@/components/AddManufactory.vue";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    const {CodeToText} =require("@/js/region/region");

    @Component({
        name: "manufactoryList",
        components: {AddManufactory, SetTableColumns}
    })
    export default class Home extends Vue {
        title = "制造单位列表";
        listData = [];
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        listTotal = 0;

        addName = "";
        editId = "";
        editData = "";
        setDialog = false;
        allSelected = [];
        tabCol = [];
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        CodeToText = CodeToText;
        tableKey = 0;

        created() {
            this.getConfig();
        }
        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.listParam.current = 1;
            }
            this.tableClearSelect();
            this.list();
        }
        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }
        getConfig() {
            userApi.getUserConfig({name:"manufactoryPageSize"}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                    this.list();
                }
            })
        }
        indexMethod(index: any) {
            return (this.listParam.current-1)*this.listParam.size+index+1;
        }
        list() {
            const params = {
                ...this.listParam,
                name: ""
            }
            manufactoryApi.page(params).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    this.listData = rData;
                    this.$nextTick(()=>{
                        let $table = this.$refs.table as HTMLFormElement;
                        if($table){
                            $table.doLayout();
                        }
                    })
                }
            })
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
            userApi.updateUserConfig({name: "manufactoryPageSize", config: val})
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        resetAddform(){
            this.addName = "";
            this.editId = "";
        }
        //0新增  1编辑 2查看  3删除
        toDetail(type: number){
            this.resetAddform();
            const dataArr = this.allSelected as any;
            let id = "";
            if(type !== 0){
                if(dataArr.length == 0){
                    this.$message.error("请先勾选");
                    return;
                }
                if(type == 3){
                    this.del2(dataArr);
                    return;
                }
                if(dataArr.length > 1 && (type == 1 || type == 2)){
                    this.$message.error("只能勾选一条");
                    return;
                }
                id = dataArr[0].id;
            }
            if(id != "0"){
                this.edit(dataArr[0]);
            }
            this.setDialog = true;
        }

        add() {
            this.addName = "";
            this.editId = "";
            this.setDialog = true;
        }
        saveSuccess(){
            this.setDialog = false;
            this.list();
        }
        saveBtn() {
            const params = {
                name: this.addName
            } as any
            if (this.editId) {
                params.id = this.editId;
            }
            manufactoryApi.update(params).then(r => {
                this.$message.success("保存成功");
                this.setDialog = false;
                this.list();
            })
        }

        edit(data: any) {
            this.addName = data.name;
            this.editId = data.id;
            this.editData = data;
            this.setDialog = true;
        }

        del2(dataArr: any){
            this.$confirm('确定要删除'+dataArr.flatMap((e:any)=>e.name).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                manufactoryApi.delete({ids: dataArr.flatMap((e:any)=>e.id).join(",")}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        handleClick() {
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
            this.refresh();
        }

        del(data: any) {
            this.$confirm('确定要删除？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                manufactoryApi.delete({id: data.id}).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        if (this.listData.length == 1 && this.listParam.current > 1) {
                            this.listParam.current--;
                        }
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }
        refresh() {
            this.listParam.current = 1;
            this.list();
        }
    }
